
<script  context="module">
    import { toast } from '@zerodevx/svelte-toast'

	export function json(response) {
		return response.json()
	}

	export async function doFetch(url, method, payload, headers) {
		const turl = url;
		let theaders = { 'Content-Type': 'application/json' };
		if(headers !== undefined) {
			theaders = headers;
		}
		let requestOptions = {
			method: method,
			headers: theaders
		};        

		if(method === 'POST' && payload !== undefined) {
			requestOptions.body = JSON.stringify(payload);
		}

		const jdata = await fetch(turl, requestOptions)
		.then(json)
		.then(function (data) {
			return data;
		})
		.catch(function (error) {
			const res = {"st": false, "msg": error};
			return res;
		});
		return jdata;
	}

	export async function doAPIPost(api_endpoint, busy_message, success_message, payload, headers={ 'Content-Type': 'application/json' }, duration=5000) {
        let res = {st: "false", msg: `Unknown error calling ${api_endpoint} API.`};
        const toast_id = toast.push(`${busy_message}, please wait...`, {
            duration: duration,
            // initial: 0,
            // progress: 0,
            dismissable: false,
            theme: {
                '--toastBackground': '#48BB78',
                '--toastProgressBackground': '#2F855A'
            }
        });

		// const turl = api_host + "/api/property_info";
		// const payload = {q: address_query};
		const jdata = await doFetch(api_endpoint, 'POST', payload, headers);
        toast.pop(toast_id);

        if(jdata.st) {
            res = jdata;
            toast.push(success_message, {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: true,
                // theme: {
                //     '--toastBackground': '#F56565',
                //     '--toastProgressBackground': '#C53030'
                // }
            });
        }else{
            toast.push(jdata.msg, {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }

        return res;
 		
	}

    export async function doAddressSearch(api_host, address_query) {
        let res = {st: "false", msg: "Unknown error searching address."};
        const toast_id = toast.push('Searching for address, please wait...', {
            duration: 5000,
            // initial: 0,
            // progress: 0,
            dismissable: false,
            theme: {
                '--toastBackground': '#48BB78',
                '--toastProgressBackground': '#2F855A'
            }
        });

		const turl = api_host + "/api/ex/property_info";
		const payload = {q: address_query};
		const jdata = await doFetch(turl, 'POST', payload);
        toast.pop(toast_id);

        if(jdata.st) {
            res = jdata;
        }else{
            toast.push(jdata.msg, {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }

        return res;
    }

</script>
